export default {
  usageTitle: {
    id: 'finder_usage_title',
    defaultMessage: 'What will you use it for?',
  },
  usageTooltip: {
    id: 'finder_usage_tooltip',
    defaultMessage:
      "We'll match your answer to the right specs, so you don't have to.",
  },
  budgetTitle: {
    id: 'finder_budget_title',
    defaultMessage: "What's your budget?",
  },
  requirementsTitle: {
    id: 'finder_requirements_title',
    defaultMessage: 'More requirements?',
  },
  sizeTitle: {
    id: 'finder_size_title',
    defaultMessage: 'What size do you want?',
  },
  conditionTitle: {
    id: 'finder_condition_title',
    defaultMessage: 'Which conditions?',
  },
  conditionTooltip: {
    id: 'finder_condition_tooltip',
    defaultMessage:
      'Every refurbished MacBook is tested and graded, so you always know what to expect.',
  },
  moreFiltersLabel: {
    id: 'finder_more_filters_label',
    defaultMessage: 'More filters',
  },
} as const
